import { ApiBaseService } from '@/services/ApiBase.service'
import { User } from '@/classes/generated-models'

export class AccountService extends ApiBaseService<User> {
  readonly apiController = 'authentication'

  constructor() {
    super()
  }

  async logout(): Promise<boolean> {
    return this.post(null, 'logout')
  }
}
